import React from 'react';
import PropTypes from 'prop-types';

const Send = ({ fill, theme, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 1.28997C21.8312 1.18224 21.6352 1.125 21.435 1.125C21.2348 1.125 21.0388 1.18224 20.87 1.28997L2.07 12.14C1.89202 12.245 1.74862 12.3997 1.65743 12.5852C1.56624 12.7706 1.53125 12.9787 1.55675 13.1837C1.58225 13.3888 1.66713 13.5819 1.80096 13.7394C1.93479 13.8968 2.11172 14.0118 2.31 14.07L8.31 15.95L8.5 16L9.31 21.69C9.32851 21.9308 9.41425 22.1615 9.55744 22.356C9.70064 22.5505 9.89555 22.7008 10.12 22.79C10.2712 22.8565 10.4348 22.8906 10.6 22.89C10.7873 22.8974 10.9739 22.8637 11.1467 22.7911C11.3195 22.7186 11.4742 22.6089 11.6 22.47L15.6 18.12L18.6 18.98C18.7459 19.0212 18.899 19.0309 19.049 19.0085C19.199 18.9861 19.3425 18.9321 19.47 18.85C19.597 18.7725 19.705 18.6676 19.7863 18.5431C19.8676 18.4185 19.9201 18.2774 19.94 18.13L22.45 2.31997C22.4869 2.12296 22.4636 1.91943 22.3834 1.73576C22.3032 1.5521 22.1696 1.39679 22 1.28997ZM5.27 12.73L16.68 6.11997L9.12 14L5.27 12.73ZM11.17 19.78L10.74 16.78L11.18 16.92L13.3 17.52L11.17 19.78ZM18.05 16.63L12.69 15.12L11.36 14.69L19.71 5.99997L18.05 16.63Z"
      fill={fill || theme.COLORS.primary}
    />
  </svg>
);

Send.propTypes = {
  fill: PropTypes.string,
  theme: PropTypes.object,
};

export default Send;
